module.exports = __webpack_public_path__ + "static/img/cuowu.ab89e279.png";